import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CompanyService, BranchService } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { SubSink } from 'subsink2';
import { Observable } from 'rxjs';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-util-cash-document-view-main',
  templateUrl: './cash-document-view-main.component.html',
  styleUrls: ['./cash-document-view-main.component.css']
})

export class CashDocumentViewMainComponent implements OnInit, OnDestroy {
  @Input() cashDoc$: Observable<any>;
  apiVisa = AppConfig.apiVisa;
  private subs = new SubSink();

  form: FormGroup;
  leftColControls = [
    {label: 'Company', formControl: 'company', type: 'text', readonly: true},
    {label: 'Reference', formControl: 'reference', type: 'text', readonly: true},
    {label: 'Remarks', formControl: 'remarks', type: 'text', readonly: true},
  ];

  rightColControls = [
    {label: 'Branch', formControl: 'branch', type: 'text', readonly: true},
    {label: 'Transaction Date', formControl: 'transactionDate', type: 'text', readonly: true},
    {label: 'Currency', formControl: 'currency', type: 'text', readonly: true},

  ];

  constructor(
    private companyService: CompanyService,
    private branchService: BranchService) {
  }

  ngOnInit() {
    this.form = new FormGroup({
      company: new FormControl(),
      branch: new FormControl(),
      reference: new FormControl(),
      transactionDate: new FormControl(),
      currency: new FormControl(),
      remarks: new FormControl(),
    });

    this.subs.sink = this.cashDoc$.subscribe(resolve => {
      this.form.patchValue({
        reference: resolve.bl_fi_cash_document_hdr.ref_no,
        transactionDate: SharedUtilitiesHelperFunctions.dateFormatter(resolve.bl_fi_cash_document_hdr.date_txn),
        currency: resolve.bl_fi_cash_document_hdr.ccy_code,
        remarks: resolve.bl_fi_cash_document_hdr.remarks,
        branch: resolve.bl_fi_cash_document_hdr.branch_code
      });
      this.companyService.getByGuid(resolve.bl_fi_cash_document_hdr.comp_guid.toString(),this.apiVisa).subscribe((resp) => {
        this.form.patchValue({
          company : resp.data.bl_fi_mst_comp.name,
        });
      });

    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
